import React from 'react'
import { GitHubCalendar } from 'react-github-calendar'
import github from './github.svg'

function InformationBlock({ userData }) {
  if (!userData) return null

  return (
    <section className='InfoBlock'>
      <h2>Information found</h2>
      <article>

      <img src={userData.avatar_url} className='avatars' alt='Avatar' />
      <ul>
      <li><p>Name: {userData.name ? userData.name : userData.login}</p></li>
      <li><p>City: {userData.location ? userData.location : 'No information'}</p> </li>
      </ul>
      <p>Public email: {userData.email ? userData.email : 'Email not available'}</p>
      <p>Followers: {userData.followers}</p>  
      <li className='bio'><p>Bio: <span>{userData.bio ? userData.bio : 'No bio available'}</span></p></li>
        <span className='githubProfile' onClick={() => window.open(userData.html_url, '_blank')}>
    <img src={github} alt='Github profile'/>
  </span>
      <div className='calendar'>
      <GitHubCalendar username={userData.login} 
      />
      </div>
      </article>
    </section>
  )
}

export default InformationBlock